import React, { useState, useEffect } from 'react';
import { 
  Button, 
  Dialog, 
  DialogContent, 
  DialogTitle, 
  IconButton, 
  Box,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const VimeoVideoPopup = ({hashParam, videoId, title = "Video" }) => {
  const [open, setOpen] = useState(true);


  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    console.log('videoId, hashParam: ', videoId, hashParam)
    if (videoId && hashParam) {
      setOpen(true);
    }
  }, [videoId, hashParam]);

  return (
    <>

      {/* Dialog popup */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        aria-labelledby="video-dialog-title"
      >
        <DialogTitle id="video-dialog-title">
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{title}</Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box 
            sx={{ 
              position: 'relative',
              paddingTop: '56.25%', // 16:9 aspect ratio
              width: '100%',
              height: 0,
              overflow: 'hidden'
            }}
          >
            <iframe
              src={`https://player.vimeo.com/video/${videoId}?h=${hashParam}&badge=0&autopause=0&autoplay=1&player_id=0&app_id=58479`}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none'
              }}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
              allowFullScreen
              title="Vimeo Video"
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

// Example usage
const DemoVideoPopup = ({demoVideo}) => {
  return (
      <VimeoVideoPopup 
        videoId={demoVideo['videoId']} 
        hashParam={demoVideo['hashParam']} 
        title={demoVideo['videoTitle']}
      />

  );
};

export default DemoVideoPopup;